<template>
	<div class="OrderConfirm_box" v-if="showDialog">
		<div class="bg_div">
			<div class="oc_mainbox">
				<div class="oc_top_title">
					{{ title }}
					<div class="close_login" @click="_Cancel">
						<span></span>
					</div>
				</div>
				<div class="oc_sure_textbox">
					<div class="head">您确定下注&ensp;{{ qh }}？</div>
					<div class="data_item">彩种：{{ cz }}</div>
					<div class="data_item">期号：{{ qh }}</div>
					<div style="padding: 10px 0px">
						<div class="detBox">
							<div class="detItem" v-for="(item, index) in shTextArr" :key="index">
								{{ item }}
							</div>
						</div>
					</div>
					<div class="data_item">
						总计<b style="color: #ec362b"> {{ allNum }} </b>注，总共<b style="color: #ec362b"> {{ money }} </b> 元
					</div>
				</div>
				<div class="oc_sure_btnbox">
					<el-button type="" @click="_Cancel">取消</el-button>
					<el-button type="primary" @click="_Confirm">确定</el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		cz: {
			type: String,
		},
		qh: {
			type: String | Number,
		},
		money: {
			type: String | Number,
		},
		shTextArr: {
			type: Array,
			default: [],
		},
		confirm: {
			type: Function,
			default: null,
		},
		cancel: {
			type: Function,
			default: null,
		},
		allNum: {
			type: Number,
			required: true,
		},
	},
	watch: {
		shTextArr(val) {},
	},
	data() {
		return {
			title: "提示",
			showDialog: false,
		};
	},

	methods: {
		show() {
			this.showDialog = true;
		},
		hide() {
			this.showDialog = false;
		},
		_Confirm() {
			if (this.money > this.$store.state.userInfo.Balance) {
				this.$message.error("您的可用余额不足，请重新选择");
			} else if (this.confirm) this.confirm();
			this.hide();
		},
		_Cancel() {
			if (this.cancel) this.cancel();
			this.hide();
		},
	},
};
</script>
<style lang="scss">
.OrderConfirm_box {
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 3333;

	.bg_div {
		position: relative;
		width: 545px;
		height: 428px;
		padding: 56px 0 0 43px;
	}

	.oc_mainbox {
		width: 457px;
		background: #ffffff;
		border-radius: 5px;
		text-align: center;
		border-radius: 10px;
		.oc_top_color {
			background: #d86556;
			height: 3px;
		}

		.oc_top_title {
			text-align: left;
			color: #ffffff;
			box-shadow: 0px 4px 7px 0 rgba(0, 0, 0, 0.12);
			background-color: #1483d1;
			line-height: 45px;
			position: relative;
			font-size: 16px;
			padding: 0 20px;
			border-radius: 10px 10px 0 0;

			// &::after {
			// 	content: "";
			// 	position: absolute;
			// 	top: 0;
			// 	left: 50%;
			// 	transform: translateX(-50%);
			// 	background-image: url("../../static/img/white_shadow.webp");
			// 	width: 54%;
			// 	height: 29px;
			// 	background-size: cover;
			// }
		}
	}

	.oc_mainbox p {
		text-align: center;
		color: #232924;
		line-height: 24px;
		// font-weight: bold;
		font-weight: 400;
	}

	.oc_sure,
	.oc_exit {
		width: 140px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		cursor: pointer;
		border-radius: 20px;
	}

	.oc_sure {
		color: white;
		background: #d86556;
		margin-right: 10px;
	}

	.oc_exit {
		color: #9b9b9b;
		background-color: #efefef;
		border: solid 1px #d5d5d5;
	}

	.oc_sure_textbox {
		font-size: 14px;

		.head {
			line-height: 45px;
			font-size: 16px;
			color: #ec362b;
			text-align: center;
			img {
				vertical-align: middle;
			}
		}

		.data_item {
			padding-left: 14px;
			line-height: 26px;
			text-align: left;
			font-size: 14px;

			b {
				font-family: "HiraginoSansGB-W3";
			}
		}

		.list_item_title {
			display: flex;
			justify-content: center;
			padding-left: 0;

			span {
				display: inline-block;
			}

			span:first-child {
				width: 40%;
				padding-left: 14px;
			}

			span:last-child {
				display: inline-block;
				width: 60%;
				overflow: hidden;
				word-break: break-all;
			}
		}

		.detBox {
			height: 100px;
			margin: 0px 14px;
			border: 1px solid #d8d8d8;
			overflow-y: auto;
			padding: 5px 5px;
			border-radius: 5px;

			.detItem {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				text-align: left;
			}
		}
	}

	.oc_sure_btnbox {
		padding: 10px 0;
		display: flex;
		justify-content: center;
		width: 100%;
		overflow: hidden;
	}

	.oc_sure_btnbox > div:hover {
		opacity: 0.9;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Elasticframe/OrderConfirm.vue